import { FC } from 'react'
import { Else, If, Then } from 'react-if'
import { Image } from '@/atoms/Image'
import { EmbeddedVideo } from '@/molecules/EmbeddedVideo'

interface PosterOrTrailerProps {
  posterUrl?: string
  youtubeUrl?: string
}

export const PosterOrTrailer: FC<PosterOrTrailerProps> = ({ youtubeUrl, posterUrl }) => (
  <If condition={youtubeUrl}>
    <Then>
      <EmbeddedVideo url={youtubeUrl as string} />
    </Then>
    <Else>
      <div className="aspect-h-9 aspect-w-16 block">
        <Image alt="movie poster" fill src={posterUrl as string} />
      </div>
    </Else>
  </If>
)
